import { CurrencyCircleDollar, FileDashed } from '@phosphor-icons/react';
import IncomeCard from '../molecules/IncomeCard';
import Text from '../../../components/atoms/Text';
import { RetentionIncome } from '../../../@types/Declarations.type';
import StepSkeleton from '../molecules/StepSkeleton';

interface Step1Props {
	retentionIncomes?: RetentionIncome;
	month: string;
	viewApprove?: boolean;
}

const Step1 = ({ retentionIncomes, month, viewApprove = true }: Step1Props) => {
	if (!retentionIncomes) {
		return (
			<StepSkeleton
				showHeader={viewApprove}
				cardsCount={1}
			/>
		);
	}

	return (
		<>
			{viewApprove && (
				<>
					<div className='self-stretch inline-flex justify-start items-center gap-2.5'>
						<CurrencyCircleDollar
							weight='duotone'
							color='var(--h-primary)'
							size={16}
						/>
						<Text
							size='body-2'
							weight='medium'
						>
							Ingresos y retenciones
						</Text>
					</div>

					<div className='self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-[#e5e5e5]' />
				</>
			)}

			{retentionIncomes.retentions.length > 0 && (
				<>
					<Text
						size='body-3'
						weight='light'
					>
						Ingresos generados con tus empleadores durante el mes de {month}.
					</Text>
					<div className='self-stretch flex flex-col gap-4'>
						{retentionIncomes.retentions.map((income, index) => (
							<IncomeCard
								key={index}
								platform={income?.issuer_code}
								amount={income?.total_taxable_amount}
								taxes={income?.taxes}
							/>
						))}
					</div>
					<div className='flex justify-between items-center w-full'>
						<Text
							size='caption'
							weight='light'
						>
							Total ingresos:
						</Text>
						<Text
							size='caption'
							weight='medium'
						>
							${' '}
							{Math.round(
								retentionIncomes.retentions.reduce((total, income) => {
									return total + (income.total_taxable_amount || 0);
								}, 0),
							).toLocaleString('es-MX')}
						</Text>
					</div>
					<div className='flex pl-2 justify-between items-center w-full'>
						<Text
							size='caption'
							weight='light'
						>
							Total ISR:
						</Text>
						<Text
							size='caption'
							weight='medium'
						>
							${' '}
							{Math.round(
								retentionIncomes.retentions.reduce((total, income) => {
									const isrTax = income.taxes?.find(
										(tax) => tax.tax_type === '01',
									);
									return total + (isrTax?.retained_amount || 0);
								}, 0),
							).toLocaleString('es-MX')}
						</Text>
					</div>

					<div className='flex pl-2 justify-between items-center w-full'>
						<Text
							size='caption'
							weight='light'
						>
							Total IVA:
						</Text>
						<Text
							size='caption'
							weight='medium'
						>
							${' '}
							{Math.round(
								retentionIncomes.retentions.reduce((total, income) => {
									const ivaTax = income.taxes?.find(
										(tax) => tax.tax_type === '02',
									);
									return total + (ivaTax?.retained_amount || 0);
								}, 0),
							).toLocaleString('es-MX')}
						</Text>
					</div>
				</>
			)}
			{retentionIncomes.retentions.length === 0 && (
				<div className='flex flex-col items-center justify-center p-8 text-center w-full'>
					<FileDashed
						size={50}
						color='#b3b3b3'
					/>
					<p className='text-h-neutral-60 text-lg mt-4'>
						No se registraron ingresos durante el mes de {month}
					</p>
				</div>
			)}
		</>
	);
};

export default Step1;
